<template>
  <div class="block-wrap">
    <!-- <BlockTitle title-type="engineering" /> -->
    <!-- <div class="content-wrap" :class="cardList.length <= 1 ? 'content-center' : ''">
      <div class="card-item" 
          v-for="(card, index) in cardList" 
          :key="index"
          @click="toDetail(card)">
        <img :src="card.logo" alt="">
        <img :src="card.activeLogo" alt="">
        <h3 class="card-title" :title="card.title">{{card.title}}</h3>
        <div class="card-desc">{{card.briefIntroduction || '-'}}</div>
      </div>
    </div> -->
    <div class="content-wrap" :class="cardList.length <= 1 ? 'content-center' : ''">
      <div class="detail-content" v-if="cardList.length">
        <h3 class="detail-content-title" :title="cardList[0].title">{{cardList[0].title}}</h3>
        <div class="detail-time-info">
          <div><span>主办方：</span><span class="value">{{cardList[0].sponsor}}</span></div>
          <div><span>活动时间：</span><span class="value">{{cardList[0]._releaseTime}}</span></div>
        </div>
        <div class="detail-info">{{cardList[0].briefIntroduction || ''}}</div>
        <div class="card-more" @click="toDetail(cardList[0])">查看详情</div>
      </div>
      <div class="img-wrap" v-if="cardList.length">
        <img :src="cardList[0].coverImg" alt="">
      </div>
    </div>
    <!-- <SplitLine /> -->
  </div>
</template>

<script>
import router from '@/router';
import BlockTitle from "@/components/BlockTitle";
import logo1 from '../../assets/images/engineer-logo-1.png';
import logo1Active from '../../assets/images/engineer-logo-1-active.png';
import logo2 from '../../assets/images/engineer-logo-2.png';
import logo2Active from '../../assets/images/engineer-logo-2-active.png';
import logo3 from '../../assets/images/engineer-logo-3.png';
import logo3Active from '../../assets/images/engineer-logo-3-active.png';
const tempList = [{
  logo: logo1,
  activeLogo: logo1Active
}, {
  logo: logo2,
  activeLogo: logo2Active,
}, {
  logo: logo3,
  activeLogo: logo3Active,
}];
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    cardList() {
      return this.list.map((item, idx) => {
        Object.assign(item, tempList[idx]);
        return item;
      })
    }
  },
  components: {
    BlockTitle,
  },
  methods: {
    toDetail(item) {
      router.push(`/activity/awards?aId=${item.id}`);
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.block-wrap {
  // background: url(../../assets/images/engineer-bg.png) no-repeat center center;
  // background-size: 100% 80%;

  .content-wrap {
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;

    .detail-content {
      width: 920px;
      min-height: 362px;
      background: rgba(6, 174, 99, 0.03);
      box-sizing: border-box;
      padding: 40px;
      padding-right: 136px;

      h3 {
        &:extend(.line2);
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #131415;
        line-height: 24px;
        margin-bottom: 20px;
      }

      .detail-time-info {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        > div {
          flex: 1;

          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #787878;
            margin-right: 10px;

            &.value {
              color: #131415;
            }
          }
        }
      }

      .detail-info {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 20px;
        margin-bottom: 40px;
      }

      .card-more {
        background: #06AE63;
        color: #fff;
        margin-left: auto;
      }
    }

    .img-wrap {
      width: 388px;
      height: 330px;
      box-sizing: border-box;
      padding: 5px;
      background: url(../../assets/images/petu_mb.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: 16px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>